import { useState } from "react";
import { ArrowDown, ArrowUp, Check, Copy, Ellipsis, Share, SquarePlus } from "lucide-react";
import { Later, Primary, Sheet, VisualStep } from "@/components/install/ui";

const iosBrowser = () => {
  const ua = navigator.userAgent;
  if (/FBAN|FBAV|Instagram|WhatsApp|Line\/|GSA\/|TikTok|Twitter/i.test(ua)) return "inapp";
  if (/CriOS|FxiOS|EdgiOS/i.test(ua)) return "other";
  return "safari";
};

const Arrow = ({ top }) => (
  <div className={`fixed z-[61] pointer-events-none flex flex-col items-center ${top ? "top-2 right-3" : "bottom-2 left-1/2 -translate-x-1/2"}`} data-testid="install-ios-arrow">
    {top && <ArrowUp size={48} strokeWidth={3} className="text-white animate-bounce drop-shadow-lg" />}
    <span className="bg-[#B23A38] text-white font-bold px-3 py-1 rounded-full shadow-lg">{top ? "Toca aquí" : "Toca aquí abajo"}</span>
    {!top && <ArrowDown size={48} strokeWidth={3} className="text-white animate-bounce drop-shadow-lg" />}
  </div>
);

const InApp = ({ onClose }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => { try { await navigator.clipboard.writeText(window.location.origin); setCopied(true); } catch { setCopied(false); } };
  return (
    <Sheet title="Ábrela en Safari" onClose={onClose} testId="install-ios-guide">
      <p className="mt-3 text-slate-600">Dentro de WhatsApp o Instagram no se puede instalar.</p>
      <ol className="mt-5 space-y-5">
        <VisualStep n="1" icon={<Copy size={28} />}>Copia el enlace</VisualStep>
        <VisualStep n="2" icon={<span className="font-black text-lg">S</span>}>Pégalo en <b>Safari</b></VisualStep>
        <VisualStep n="3" icon={<Check size={28} />} red>Pulsa <b>Instalar</b> otra vez</VisualStep>
      </ol>
      <Primary onClick={copy} data-testid="install-ios-copy">{copied ? <><Check size={22} />¡Copiado! Ve a Safari</> : <><Copy size={22} />Copiar enlace</>}</Primary>
      <Later onClick={onClose} data-testid="install-ios-later" />
    </Sheet>
  );
};

export const IOSGuide = ({ onClose }) => {
  const kind = iosBrowser();
  if (kind === "inapp") return <InApp onClose={onClose} />;
  const safari = kind === "safari";
  return (
    <>
      <Arrow top={!safari} />
      <Sheet title="Instálala en 3 toques" onClose={onClose} top={safari} testId="install-ios-guide">
        <ol className="mt-6 space-y-5">
          <VisualStep n="1" icon={<Share size={28} />}>Toca <b>Compartir</b>{safari && <span className="block text-sm text-slate-500">Si no lo ves, toca antes <Ellipsis size={16} className="inline" /></span>}</VisualStep>
          <VisualStep n="2" icon={<SquarePlus size={28} />}><b>Añadir a pantalla de inicio</b></VisualStep>
          <VisualStep n="3" icon={<span className="font-bold text-sm">Añadir</span>} red>Toca <b>Añadir</b></VisualStep>
        </ol>
        <Primary onClick={onClose} data-testid="install-ios-ok">¡Vamos!</Primary>
      </Sheet>
    </>
  );
};
